import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tag } from 'ui';

import type { TFunction } from 'i18next';

export type AiProgramTagVariant = 'student' | 'teacher';

/**
 * Texto de la etiqueta (también para el nombre accesible de las tarjetas que lo sustituyen). Interpola
 * el nombre que cada tenant da al Panel IA y al Tutor IA para no contradecir al resto de la app.
 */
export function getAiProgramTagLabel(t: TFunction, variant: AiProgramTagVariant): string {
  return variant === 'teacher' ? t('course:Includes x', { name: t('chatbot:ai_teacher_panel') }) : t('course:x available', { name: t('chatbot:Tutor IA') });
}

type AiProgramTagProps = {
  id?: string;
  variant?: AiProgramTagVariant;
};

/** Etiqueta informativa de las tarjetas de programa con IA; en Figma el alumno lleva el emoji ✨. */
function AiProgramTag({ id, variant = 'teacher' }: AiProgramTagProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="ai-program-tag" id={id}>
      <Tag
        className={`ai-program-tag--${variant}`}
        color="pastel-darkblue"
        label={getAiProgramTagLabel(t, variant)}
        leftIcon={variant === 'student' ? 'sparkles' : 'ai'}
        shape="pill"
      />
    </div>
  );
}

export default AiProgramTag;
